import { IDecisionTreeConfigSubRoot } from './types';

export const selectDecisionTreeGroupColumnId = (state: IDecisionTreeConfigSubRoot) =>
  state.decisionTreeConfig.columnGroupId;

export const selectDecisionTreeDefaultPortGrouping = (
  state: IDecisionTreeConfigSubRoot
) => state.decisionTreeConfig.defaultPortGrouping;
